import { hasCapability } from "@/utils/capability";

import { useActiveScopeCapabilities } from "../capability/useActiveScopeCapabilities";

/**
 * Club surfaces (`CLUB:READ` / `CLUB:CREATE` / `CLUB:WRITE` / `CLUB:DELETE`)
 * checked against the active scope's capability set. Strict RBAC — the backend
 * resolver is the single source of truth and the S0 grants give every legacy
 * member the matching keys. See docs/capabilities.md.
 */
export const useClubPermissions = () => {
  const { capabilities } = useActiveScopeCapabilities();

  const canSeeClubs = hasCapability(capabilities, "CLUB:READ");
  const canCreateClub = hasCapability(capabilities, "CLUB:CREATE");
  const canUpdateClub = hasCapability(capabilities, "CLUB:WRITE");
  const canDeleteClub = hasCapability(capabilities, "CLUB:DELETE");

  return { canSeeClubs, canCreateClub, canUpdateClub, canDeleteClub };
};
